import { useDispatch } from "react-redux";
import { AppDispatch, useSelector } from "@/core/redux/store";
import { useEffect, useState } from "react";
import SupplierTabs from "./supplier-tabs/supplier-tabs";
import { ListChecks, ListCollapse, Timer } from "lucide-react";
import SupplierTable from "./supplier-table/supplier-table";
import { getContributionPerformance } from "@/core/redux/thunks/dashboardThunk";
import { formatNumber } from "../processed-sources/processed-sources";
import { Skeleton } from "@/shared/components/ui/skeleton";

export default function ContributionPerformance() {
  const contributionPerformance = useSelector((state) => state.dashboard.contributionPerformance);
  const isLoading = useSelector((state) => state.dashboard.loadingContributionPerformance);
  const dispatch = useDispatch<AppDispatch>();
  const userDetail = useSelector((state) => state.user.me);
  const company = userDetail?.company;
  const filterParams = useSelector((state) => state.dashboard.filterParams);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  useEffect(() => {
    if (!company?.id) return;
    dispatch(getContributionPerformance({ companyId: company.id, ...filterParams }));
  }, [company?.id, filterParams]);
  const {
    totalAnswerTime = 0,
    totalTimeSpent = 0,
    totalContributedItemCount = 0,
    totalContributedUserCount = 0,
  } = contributionPerformance ?? {};
  return (
    <div className="w-full border border-[#e5e5e5] bg-white rounded-[16px]  h-[576px]">
      <div className="border-b border-[#e4e4e7] h-[80px] flex items-center px-[20px] py-[16px]">
        <div className="flex justify-between items-center w-full">
          <div className="flex flex-col">
            <div className="text-[16px] font-[700] text-primary leading-[24px]">
              Katkı Performası
            </div>
            <div className="text-[14px] font-[600] text-muted-foreground leading-[20px] mt-[4px]">
              Toplam katkı sağlayan kişi sayısı
            </div>
          </div>
          <div className="text-[30px] font-[Inter] font-[700] text-foreground leading-[32px]">
            {isLoading ? <Skeleton className="w-[60px] h-[20px] mt-[4px]" /> : formatNumber(totalContributedUserCount)}
          </div>
        </div>
      </div>
      {/* tabs */}
      <SupplierTabs
        activeTabIndex={activeTabIndex}
        setActiveTabIndex={setActiveTabIndex}
      />

      <div className="flex pt-[20px] pb-[16px]">
        <div className="px-[16px] flex-1 border-r border-[#e4e4e7]">
          <div className="flex gap-[8px]">
            <div className="size-[40px] bg-white rounded-full flex items-center justify-center border border-[#e4e4e7]">
              <ListCollapse size={16} color="#71717A" />
            </div>
            <div className="flex flex-col">
              <div className="text-muted-foreground mb-[2px] text-[14px] font-600 leading-[20px]">
                Cevap Süresi
              </div>
              <div className="text-[16px] font-[Inter] font-[700] text-primary leading-[24px]">
                {isLoading ? <Skeleton className="w-[60px] h-[20px] mt-[4px]" /> : formatNumber(totalAnswerTime)}
              </div>
            </div>
          </div>
        </div>
        <div className="px-[16px] flex-1 border-r border-[#e4e4e7]">
          <div className="flex gap-[8px]">
            <div className="size-[40px] bg-white rounded-full flex items-center justify-center border border-[#e4e4e7]">
              <Timer size={16} color="#71717A" />
            </div>
            <div className="flex flex-col">
              <div className="text-muted-foreground mb-[2px] text-[14px] font-600 leading-[20px]">
                Harcanan Zaman
              </div>
              <div className="text-[16px] font-[Inter] font-[700] text-primary leading-[24px]">
                {isLoading ? <Skeleton className="w-[60px] h-[20px] mt-[4px]" /> : formatNumber(totalTimeSpent)}
              </div>
            </div>
          </div>
        </div>
        <div className="px-[16px] flex-1 ">
          <div className="flex gap-[8px]">
            <div className="size-[40px] bg-white rounded-full flex items-center justify-center border border-[#e4e4e7]">
              <ListChecks size={16} color="#71717A" />
            </div>
            <div className="flex flex-col">
              <div className="text-muted-foreground mb-[2px] text-[14px] font-600 leading-[20px]">
                Katkı Sağlanan Madde
              </div>
              <div className="text-[16px] font-[Inter] font-[700] text-primary leading-[24px]">
                {isLoading ? <Skeleton className="w-[60px] h-[20px] mt-[4px]" /> : formatNumber(totalContributedItemCount)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <SupplierTable users={contributionPerformance?.users ?? []} isLoading={isLoading} />
    </div>
  );
}
